import script from "./BodyRow.vue?vue&type=script&lang=js"
export * from "./BodyRow.vue?vue&type=script&lang=js"

import "./BodyRow.vue?vue&type=style&index=0&id=343d9dae&lang=scss&scoped=true"
script.__scopeId = "data-v-343d9dae"

export default script